module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro4.5db84285.mp3";